import { useState, useEffect } from "react";
import styles from "./Education.module.css";

const Education = (props) => {
  const [visible, setIsVisible] = useState(false);

  const { scrollOffset } = props;

  useEffect(() => {
    const bodyRect = document.body.getBoundingClientRect();
    const elementRect = document
      .getElementsByClassName(styles["education"])[0]
      .getBoundingClientRect();

    const offset = elementRect.top - bodyRect.top;

    const elementVisible = scrollOffset + window.innerHeight - offset;
    const elementSize = elementRect.bottom - elementRect.top;

    if (elementVisible >= elementSize / 2) setIsVisible(true);
    else setIsVisible(false);
  }, [scrollOffset]);

  return (
    <div className={styles["education"]}>
      <p
        className={`${styles["heading"]} ${
          !visible && styles["heading--hidden"]
        }`}>
        EDUCATION
      </p>
      <ul
        className={`${styles["schools"]} ${
          !visible && styles["schools--hidden"]
        }`}>
        <li>
          <div>
            <p className={styles["name"]}>
              Motilal Nehru National Institute of Technology Allahabad,
              Prayagraj, India
            </p>
            <p className={styles["course"]}>
              B. Tech in Information Technology
            </p>
            <p className={styles["grades"]}>CPI - 9.02 (Upto 5th semester)</p>
          </div>
          <div className={styles["duration"]}>2019 - Present</div>
        </li>
        <li>
          <div>
            <p className={styles["name"]}>
              St. Mary's Convent Sr. Sec. School, Bhopal, India
            </p>
            <p className={styles["course"]}>AISSCE (PCM + IP)</p>
            <p className={styles["grades"]}>GPA - 96.2%</p>
          </div>
          <div className={styles["duration"]}>2017 - 2019</div>
        </li>
        <li>
          <div>
            <p className={styles["name"]}>
              St. Mary's Convent Sr. Sec. School, Bhopal, India
            </p>
            <p className={styles["course"]}>AISSE</p>
            <p className={styles["grades"]}>CGPA - 9.6</p>
          </div>
          <div className={styles["duration"]}>2017</div>
        </li>
      </ul>
    </div>
  );
};

export default Education;
